import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import withStyles from '@material-ui/core/styles/withStyles';
import Checkbox from '@material-ui/core/Checkbox';
import licenseSettingsMapping from 'mappings/licenseSettingsMapping';

import styles from 'assets/jss/material-dashboard-pro-react/views/licensingStyles';

class LicensingTable extends Component {
	render() {
		const features = licenseSettingsMapping(this.props.licenseSettings);

		const emptyResultsFoundText = !features
			? <div className={this.props.classes.noResultsFound}>No Results Found</div>
			: null;

		return (
			<div className={`ReactTable -striped -highlight ${this.props.classes.wrapper}`}>
				{features && (
					<table className="rt-table">
						<tbody className="rt-tbody">
							{features.map((feature) => {
								if (feature?.items?.length > 0) {
									return feature.items.map((subFeature, index) => {
										return (
											<tr
												key={index}
												className="rt-tr rt-tr-auto-odd-even"
											>
												<td className="rt-td">{index === 0 ? feature.label : ''}</td>
												<td className="rt-td">
													<Checkbox
														className={subFeature.isActive ? this.props.classes.checkBoxActive : ''}
														checked={subFeature.isActive}
														color='primary'
														disabled
													/>
													{subFeature.label}
												</td>
											</tr>
										);
									})
								} else {
									return null;
								}
							})}
						</tbody>
					</table>
				)}
				{emptyResultsFoundText}
			</div>
		);
	}
}

const mapStateToProps = ({ settings }) => ({
	licenseSettings: settings.licenseSettings
});

export default compose(
	withStyles(styles),
	connect(mapStateToProps),
)(LicensingTable);
